var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project__details"},_vm._l((JSON.parse(_vm.details)),function(detail,index){return _c('div',{key:index,staticClass:"detail__accordions"},[_c('project-details-child',{attrs:{"title":detail.title,"description":detail.description}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib?{}!./scripts/vue/ProjectDetails.vue?vue&type=template&id=48103470&scoped=true&
// module id = 338
// module chunks = 0